import { jsxs as e, Fragment as l, jsx as t } from "react/jsx-runtime";
import { useTranslation as h, centsToUnits as x } from "@systemeio/ui";
import { CurrencyBadge as i } from "../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as d } from "../../../../utils/get-amount-with-currency-symbol.mjs";
import { useLocaleContext as b } from "../../../../providers/use-locale-provider.mjs";
const _ = ({ calculatePrice: s, currency: n, finalAmount: f }) => {
  const { locale: m } = b(), { t: p } = h(), o = s == null ? void 0 : s.netAmount, a = o !== void 0 && o !== f, r = !!(s != null && s.tax) && s.tax.rate > 0;
  return /* @__PURE__ */ e(l, { children: [
    a && /* @__PURE__ */ e("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ t("span", { className: "text-[14px]", children: p("public_pages_purchase.subtotal") }),
      /* @__PURE__ */ e("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ t(i, { currency: n }),
        /* @__PURE__ */ t("span", { className: "text-[14px] font-semibold", children: d(x(o), n, m) })
      ] })
    ] }),
    r && /* @__PURE__ */ e("div", { className: "flex w-full items-center justify-between", children: [
      /* @__PURE__ */ t("span", { className: "text-[14px]", children: p("public_pages_purchase.vat_percent", {
        percent: s.tax.rate
      }) }),
      /* @__PURE__ */ e("div", { className: "flex items-center gap-2.5", children: [
        /* @__PURE__ */ t(i, { currency: n }),
        /* @__PURE__ */ t("span", { className: "text-[14px] font-semibold", children: d(
          x(s.tax.amount),
          n,
          m
        ) })
      ] })
    ] }),
    (a || r) && /* @__PURE__ */ t("div", { className: "bg-text-secondary/30 h-[1px] w-full" })
  ] });
};
export {
  _ as PriceBreakdown
};
